import { Controller } from "@hotwired/stimulus";
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

Chart.register(ChartDataLabels);

// Connects to data-controller="visitor-count-chart"
export default class extends Controller {
  static targets = [
    "overallCanvas",
    "summaryCanvas",
    "templeCanvas",
    "otherCanvas",
    "golfCanvas",
    "leisureCanvas",
    "farmCanvas",
    "michinoekiChichibuCanvas",
    "chichibuMatsuriKaikanCanvas",
    "chichibuMeisenkanCanvas",
    "kankoJohoKanCanvas",
    "michinoekiRyuseiKaikanCanvas",
    "yoshidaGenkimuraCanvas",
    "otakiOnsenYuyukanCanvas",
    "michinoekiArakawaCanvas"
  ];

  connect() {
    console.log("VisitorCount Chart connected");
    const url = this.data.get("url");
    this.renderChart(url);
  }

  async renderChart(url) {
    const response = await fetch(url);
    const data = await response.json();

    const datalabelsOptions = {
      anchor: "end",
      align: "end",
      color: "#333",
      font: { weight: "bold", size: 10 },
      formatter: (value) => {
        return value.toLocaleString();
      }
    };

    if (this.hasOverallCanvasTarget) {
      if (this.overallChart) this.overallChart.destroy();
      this.overallChart = new Chart(this.overallCanvasTarget, {
        type: "bar",
        data: data.overall_series,
        options: {
          responsive: true,
          plugins: {
            title: { display: true, text: "秩父市 入込数（年別比較）" },
            datalabels: datalabelsOptions,
            legend: { position: "bottom" }
          },
          scales: {
            y: {
              beginAtZero: true,
              title: { display: true, text: "入込数（人）" }
            },
            x: {
              title: { display: true, text: "月" }
            }
          }
        }
      });
    }

    if (this.hasSummaryCanvasTarget) {
      if (this.summaryChart) this.summaryChart.destroy();
      this.summaryChart = new Chart(this.summaryCanvasTarget, {
        type: "bar",
        data: data.summary_series,
        options: {
          responsive: true,
          plugins: {
            title: {
              display: true,
              text: "秩父市 入込数（年別比較）"
            },
            datalabels: datalabelsOptions,
            legend: { position: "bottom" }
          },
          scales: {
            y: {
              beginAtZero: true,
              title: { display: true, text: "入込数（人）" }
            },
            x: {
              title: { display: true, text: "月" }
            }
          }
        }
      });
    }

    if (this.hasTempleCanvasTarget) {
      if (this.templeChart) this.templeChart.destroy();
      this.templeChart = new Chart(this.templeCanvasTarget, {
        type: "bar",
        data: data.temple_series,
        options: {
          responsive: true,
          plugins: {
            title: { display: true, text: "寺社仏閣 入込数（年別比較）" },
            datalabels: datalabelsOptions,
            legend: { position: "bottom" }
          },
          scales: {
            y: {
              beginAtZero: true,
              title: { display: true, text: "入込数（人）" }
            },
            x: { title: { display: true, text: "月" } }
          }
        }
      });
    }

    if (this.hasGolfCanvasTarget) {
      if (this.golfChart) this.golfChart.destroy();
      this.golfChart = new Chart(this.golfCanvasTarget, {
        type: "bar",
        data: data.golf_series,
        options: {
          responsive: true,
          plugins: {
            title: { display: true, text: "ゴルフ場 入込数（年別比較）" },
            datalabels: datalabelsOptions,
            legend: { position: "bottom" }
          },
          scales: {
            y: {
              beginAtZero: true,
              title: { display: true, text: "入込数（人）" }
            },
            x: { title: { display: true, text: "月" } }
          }
        }
      });
    }
    if (this.hasLeisureCanvasTarget) {
      if (this.leisureChart) this.leisureChart.destroy();
      this.leisureChart = new Chart(this.leisureCanvasTarget, {
        type: "bar",
        data: data.leisure_series,
        options: {
          responsive: true,
          plugins: {
            title: { display: true, text: "レジャー施設 入込数（年別比較）" },
            datalabels: datalabelsOptions,
            legend: { position: "bottom" }
          },
          scales: {
            y: {
              beginAtZero: true,
              title: { display: true, text: "入込数（人）" }
            },
            x: { title: { display: true, text: "月" } }
          }
        }
      });
    }
    if (this.hasFarmCanvasTarget) {
      if (this.farmChart) this.farmChart.destroy();
      this.farmChart = new Chart(this.farmCanvasTarget, {
        type: "bar",
        data: data.farm_series,
        options: {
          responsive: true,
          plugins: {
            title: { display: true, text: "農園 入込数（年別比較）" },
            datalabels: datalabelsOptions,
            legend: { position: "bottom" }
          },
          scales: {
            y: {
              beginAtZero: true,
              title: { display: true, text: "入込数（人）" }
            },
            x: { title: { display: true, text: "月" } }
          }
        }
      });
    }

    if (this.hasFarmCanvasTarget) {
      if (this.farmChart) this.farmChart.destroy();
      this.farmChart = new Chart(this.farmCanvasTarget, {
        type: "bar",
        data: data.farm_series,
        options: {
          responsive: true,
          plugins: {
            title: { display: true, text: "農園 入込数（年別比較）" },
            datalabels: datalabelsOptions,
            legend: { position: "bottom" }
          },
          scales: {
            y: {
              beginAtZero: true,
              title: { display: true, text: "入込数（人）" }
            },
            x: { title: { display: true, text: "月" } }
          }
        }
      });
    }

    if (this.hasOtherCanvasTarget) {
      if (this.otherChart) this.otherChart.destroy();
      this.otherChart = new Chart(this.otherCanvasTarget, {
        type: "bar",
        data: data.other_series,
        options: {
          responsive: true,
          plugins: {
            title: {
              display: true,
              text: "観光地（寺社仏閣除く） 入込数（年別比較）"
            },
            datalabels: datalabelsOptions,
            legend: { position: "bottom" }
          },
          scales: {
            y: {
              beginAtZero: true,
              title: { display: true, text: "入込数（人）" }
            },
            x: { title: { display: true, text: "月" } }
          }
        }
      });
    }

    if (this.hasMichinoekiChichibuCanvasTarget) {
      if (this.michinoekiChichibuChart) this.michinoekiChichibuChart.destroy();
      this.michinoekiChichibuChart = new Chart(
        this.michinoekiChichibuCanvasTarget,
        {
          type: "bar",
          data: data.michinoeki_chichibu_series,
          options: {
            responsive: true,
            plugins: {
              title: {
                display: true,
                text: "道の駅ちちぶ 入込数（年別比較）"
              },
              datalabels: datalabelsOptions,
              legend: { position: "bottom" }
            },
            scales: {
              y: {
                beginAtZero: true,
                title: { display: true, text: "入込数（人）" }
              },
              x: { title: { display: true, text: "月" } }
            }
          }
        }
      );
    }
    if (this.hasChichibuMatsuriKaikanCanvasTarget) {
      if (this.chichibuMatsuriKaikanChart)
        this.chichibuMatsuriKaikanChart.destroy();
      this.chichibuMatsuriKaikanChart = new Chart(
        this.chichibuMatsuriKaikanCanvasTarget,
        {
          type: "bar",
          data: data.chichibu_matsuri_kaikan_series,
          options: {
            responsive: true,
            plugins: {
              title: {
                display: true,
                text: "秩父まつり会館 入込数（年別比較）"
              },
              datalabels: datalabelsOptions,
              legend: { position: "bottom" }
            },
            scales: {
              y: {
                beginAtZero: true,
                title: { display: true, text: "入込数（人）" }
              },
              x: { title: { display: true, text: "月" } }
            }
          }
        }
      );
    }
    if (this.hasChichibuMeisenkanCanvasTarget) {
      if (this.chichibuMeisenkanChart) this.chichibuMeisenkanChart.destroy();
      this.chichibuMeisenkanChart = new Chart(
        this.chichibuMeisenkanCanvasTarget,
        {
          type: "bar",
          data: data.chichibu_meisenkan_series,
          options: {
            responsive: true,
            plugins: {
              title: {
                display: true,
                text: "ちちぶ銘仙館 入込数（年別比較）"
              },
              datalabels: datalabelsOptions,
              legend: { position: "bottom" }
            },
            scales: {
              y: {
                beginAtZero: true,
                title: { display: true, text: "入込数（人）" }
              },
              x: { title: { display: true, text: "月" } }
            }
          }
        }
      );
    }
    if (this.hasKankoJohoKanCanvasTarget) {
      if (this.kankoJohoKanChart) this.kankoJohoKanChart.destroy();
      this.kankoJohoKanChart = new Chart(this.kankoJohoKanCanvasTarget, {
        type: "bar",
        data: data.kanko_joho_kan_series,
        options: {
          responsive: true,
          plugins: {
            title: {
              display: true,
              text: "観光情報館 入込数（年別比較）"
            },
            datalabels: datalabelsOptions,
            legend: { position: "bottom" }
          },
          scales: {
            y: {
              beginAtZero: true,
              title: { display: true, text: "入込数（人）" }
            },
            x: { title: { display: true, text: "月" } }
          }
        }
      });
    }
    if (this.hasMichinoekiRyuseiKaikanCanvasTarget) {
      if (this.michinoekiRyuseiKaikanChart)
        this.michinoekiRyuseiKaikanChart.destroy();
      this.michinoekiRyuseiKaikanChart = new Chart(
        this.michinoekiRyuseiKaikanCanvasTarget,
        {
          type: "bar",
          data: data.michinoeki_ryusei_kaikan_series,
          options: {
            responsive: true,
            plugins: {
              title: {
                display: true,
                text: "道の駅龍勢会館 入込数（年別比較）"
              },
              datalabels: datalabelsOptions,
              legend: { position: "bottom" }
            },
            scales: {
              y: {
                beginAtZero: true,
                title: { display: true, text: "入込数（人）" }
              },
              x: { title: { display: true, text: "月" } }
            }
          }
        }
      );
    }
    if (this.hasYoshidaGenkimuraCanvasTarget) {
      if (this.yoshidaGenkimuraChart) this.yoshidaGenkimuraChart.destroy();
      this.yoshidaGenkimuraChart = new Chart(
        this.yoshidaGenkimuraCanvasTarget,
        {
          type: "bar",
          data: data.yoshida_genkimura_series,
          options: {
            responsive: true,
            plugins: {
              title: {
                display: true,
                text: "吉田元気村 入込数（年別比較）"
              },
              datalabels: datalabelsOptions,
              legend: { position: "bottom" }
            },
            scales: {
              y: {
                beginAtZero: true,
                title: { display: true, text: "入込数（人）" }
              },
              x: { title: { display: true, text: "月" } }
            }
          }
        }
      );
    }
    if (this.hasOtakiOnsenYuyukanCanvasTarget) {
      if (this.otakiOnsenYuyukanChart) this.otakiOnsenYuyukanChart.destroy();
      this.otakiOnsenYuyukanChart = new Chart(
        this.otakiOnsenYuyukanCanvasTarget,
        {
          type: "bar",
          data: data.otaki_onsen_yuyukan_series,
          options: {
            responsive: true,
            plugins: {
              title: {
                display: true,
                text: "大滝温泉遊湯館 入込数（年別比較）"
              },
              legend: { position: "bottom" },
              datalabels: datalabelsOptions
            },
            scales: {
              y: {
                beginAtZero: true,
                title: { display: true, text: "入込数（人）" }
              },
              x: { title: { display: true, text: "月" } }
            }
          }
        }
      );
    }
    if (this.hasMichinoekiArakawaCanvasTarget) {
      if (this.michinoekiArakawaChart) this.michinoekiArakawaChart.destroy();
      this.michinoekiArakawaChart = new Chart(
        this.michinoekiArakawaCanvasTarget,
        {
          type: "bar",
          data: data.michinoeki_arakawa_series,
          options: {
            responsive: true,
            plugins: {
              title: {
                display: true,
                text: "道の駅あらかわ 入込数（年別比較）"
              },
              datalabels: datalabelsOptions,
              legend: { position: "bottom" }
            },
            scales: {
              y: {
                beginAtZero: true,
                title: { display: true, text: "入込数（人）" }
              },
              x: { title: { display: true, text: "月" } }
            }
          }
        }
      );
    }
  }
}
